<mat-form-field appearance="outline" class="w-100">
    <mat-select
        disableOptionCentering
        [value]="selectedOption()"
        [disabled]="disabled()"
        [compareWith]="compareCountries"
        (selectionChange)="onSelectionChange($event.value)">
        <mat-select-trigger>
            @if (selectedOption(); as selected) {
                <app-country-option [country]="selected"></app-country-option>
            }
        </mat-select-trigger>
        @for (country of countryOptions(); track trackByCountry($index, country)) {
            <mat-option [value]="country">
                <app-country-option [country]="country"></app-country-option>
            </mat-option>
        }
    </mat-select>
</mat-form-field>
